import { Action } from 'redux';

import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

import { SortContent } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';

export interface SortContentAction extends Action {
  order: IOrderClause[];
}

export function sortContent(order: IOrderClause[]): SortContentAction {
  return {
    type: SortContent,
    order
  };
}

export const isSortContentAction = isActionFactory<SortContentAction>(SortContent);
